import { useCallback, useEffect, useState } from "react";

const read = (key, initial) => {
  try { return localStorage.getItem(key) ?? initial; } catch { return initial; }
};

// useState that survives reloads by mirroring the value to localStorage; reloads when the key changes.
export default function useDraft(key, initial = "") {
  const [state, setState] = useState(() => ({ key, value: read(key, initial) }));
  if (state.key !== key) setState({ key, value: read(key, initial) });
  const value = state.key === key ? state.value : read(key, initial);
  useEffect(() => {
    const t = setTimeout(() => {
      try { value ? localStorage.setItem(key, value) : localStorage.removeItem(key); } catch { /* quota */ }
    }, 300);
    return () => clearTimeout(t);
  }, [key, value]);
  const setValue = useCallback((v) => setState((s) => ({ ...s, value: typeof v === "function" ? v(s.value) : v })), []);
  return [value, setValue];
}
